export default "__VITE_ASSET__dDDWH5SEROTs7wiZgIgc1Q__"